import { AlertCircle } from '@untitledui/icons';
import { Icon } from '../../../components/general/Icon';
import { Text } from '../../../components/general/Text';
import { useGcsStore } from '../../../store/useGcsStore';
import { selectVehicleMcErrorDescription } from '../../../store/selectors/selectVehicleMcErrorDescription';
import type { VehicleId } from '../../../types/gcs/vehicle';

interface McErrorTileProps {
  gcsId: string;
  vehicleId: VehicleId;
}

export function McErrorTile({ gcsId, vehicleId }: McErrorTileProps) {
  const errorDescription = useGcsStore((state) => selectVehicleMcErrorDescription(state.data, gcsId, vehicleId));

  if (!errorDescription) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        border: 'var(--card-border-stroke) var(--card-border-style) var(--card-border-color)',
        borderRadius: 'var(--card-border-radius)',
        padding: '16px'
      }}
    >
      <Icon icon={AlertCircle} size={20} color='var(--color-error)' />
      <Text variant='body2-medium'>{errorDescription}</Text>
    </div>
  );
}
